// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media(max-width:1279px){.overview[data-v-758ad603]{background:#f1f1f4}}@media(max-width:1279px){.overview__title[data-v-758ad603]{font-size:22px!important}}@media(max-width:767px){.overview__title[data-v-758ad603]{padding:0 0 10px!important;font-size:18px!important}}", ""]);
// Exports
module.exports = exports;
